<!-- 获取账号下所有授权停车场的编码接口内容 -->
<template>
    <div class="">
        <right-structure :Pdatas='infoData'>
            <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
            <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
        </right-structure>
    </div>
</template>

<script>
import structure from "@/components/commonStructure"

export default {
    name: '',
    components: {
        'right-structure': structure,
    },
    props:['commonUrls'],
    data() {
        return {
            requestBody: {
              "communityId": 1,
              "phone": "13838380438"
            },
            responseCode: {
              "data": {
                "address": "101号",
                "communityId": 1000001,
                "doorList": [
                  {
                    "doorId": 114,
                    "doorName": "asdfs",
                    "doorNo": 1
                  },
                  {
                    "doorId": 113,
                    "doorName": "asdfasf",
                    "doorNo": 1
                  },
                  {
                    "doorId": 112,
                    "doorName": "111",
                    "doorNo": 1
                  },
                  {
                    "doorId": 111,
                    "doorName": "lau_test",
                    "doorNo": 1
                  },
                  {
                    "doorId": 110,
                    "doorName": "tede",
                    "doorNo": 1
                  },
                  {
                    "doorId": 25,
                    "doorName": "02B"
                  },
                  {
                    "doorId": 24,
                    "doorName": "02A"
                  },
                  {
                    "doorId": 23,
                    "doorName": "01B"
                  },
                  {
                    "doorId": 22,
                    "doorName": "01A"
                  },
                  {
                    "doorId": 18,
                    "doorName": "021",
                    "doorNo": 2
                  },
                  {
                    "doorId": 17,
                    "doorName": "罗凯测试18-4",
                    "doorNo": 4
                  },
                  {
                    "doorId": 16,
                    "doorName": "罗凯测试18-3",
                    "doorNo": 3
                  },
                  {
                    "doorId": 15,
                    "doorName": "罗凯测试18-2",
                    "doorNo": 2
                  },
                  {
                    "doorId": 14,
                    "doorName": "罗凯测试18-1",
                    "doorNo": 1
                  },
                  {
                    "doorId": 13,
                    "doorName": "23",
                    "doorNo": 1
                  },
                  {
                    "doorId": 12,
                    "doorName": "04",
                    "doorNo": 4
                  },
                  {
                    "doorId": 11,
                    "doorName": "03",
                    "doorNo": 3
                  },
                  {
                    "doorId": 10,
                    "doorName": "02",
                    "doorNo": 2
                  },
                  {
                    "doorId": 9,
                    "doorName": "01",
                    "doorNo": 1
                  },
                  {
                    "doorId": 8,
                    "doorName": "测试2门22",
                    "doorNo": 2
                  },
                  {
                    "doorId": 7,
                    "doorName": "测试1门11555",
                    "doorNo": 1
                  },
                  {
                    "doorId": 6,
                    "doorName": "01",
                    "doorNo": 1
                  },
                  {
                    "doorId": 5,
                    "doorName": "02",
                    "doorNo": 2
                  },
                  {
                    "doorId": 4,
                    "doorName": "01",
                    "doorNo": 1
                  },
                  {
                    "doorId": 3,
                    "doorName": "99-01",
                    "doorNo": 1
                  },
                  {
                    "doorId": 2,
                    "doorName": "98-01",
                    "doorNo": 1
                  },
                  {
                    "doorId": 1,
                    "doorName": "01",
                    "doorNo": 1
                  }
                ],
                "phone": "13425730812",
                "personnelId": 1,
                "physicalCardNoList": "27AB95F0",
                "userName": "霆锋1",
                "validFrom": "20200310000000",
                "validTo": "20300312000000"
              },
              "message": "业务成功",
              "resultCode": 0,
              "status": 1
            },
            infoData: {
                explain: "第三方接入系统请求开放平台查询用户的小区通行权限",
                t_url: this.commonUrls.test+"getCommunityPersonnelInfo",
                p_url: this.commonUrls.prod+"getCommunityPersonnelInfo",
                precondition: "无",
                fitSystem: "门禁系统",
                pattern: "开放平台提供接口, 第三方接入系统主动请求",
                Q_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'communityId', info2: '是', info3: 'Long', info4: '小区编号' },
                      { info1: 'phone', info2: '是', info3: 'String', info4: '手机号码' }
                        ]
                }],
                R_params: [{
                    titleName: null,
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'communityId', info2: '是', info3: 'Long', info4: '小区编号' },
                      { info1: 'phone', info2: '是', info3: 'String', info4: '手机号码' },
                      { info1: 'userName', info2: '是', info3: 'String', info4: '用户名' },
                      { info1: 'personnelId', info2: '是', info3: 'Integer', info4: '用户编号' },
                      { info1: 'address', info2: '是', info3: 'String', info4: '地址' },
                      { info1: 'validFrom', info2: '是', info3: 'String', info4: '有效开始时间，格式: yyyyMMddHHmmss' },
                      { info1: 'validTo', info2: '是', info3: 'String', info4: '有效结束时间，格式: yyyyMMddHHmmss' },
                      { info1: 'physicalCardNoList', info2: '否', info3: 'String', info4: '用户绑定卡，物理卡号列表，多个以逗号分隔' },
                      { info1: 'doorList', info2: '是', info3: 'JSONArray', info4: '门权限列表' },
                        ]
                },{
                    titleName: 'doorList',
                    tabledata: [{ tableHead: '参数名', tdName: 'info1' }, { tableHead: '是否必填', tdName: 'info2' }, { tableHead: '类型', tdName: 'info3' }, { tableHead: '说明', tdName: 'info4' }],
                    td: [
                      { info1: 'doorId', info2: '是', info3: 'Integer', info4: '门id' },
                      { info1: 'doorNo', info2: '是', info3: 'String', info4: '门编号' },
                      { info1: 'doorName', info2: '是', info3: 'String', info4: '门名称' },
                    ]
                }],
                codeStatus: [{
                    titleName: null,
                    tabledata: [{ tableHead: '状态码', tdName: 'info1' }, { tableHead: '说明', tdName: 'info2' }],
                    td: [{ info1: '000110', info2: '失败', }, { info1: '00110000', info2: '失败', }, { info1: '110000', info2: '失败', }]
                }],
            }
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
// @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/acms/community/getCommunityPersonnelInfo.vue